import {useEffect} from 'react';

import {QueryParamsForTaggingEnum} from 'presentation/constants';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {useStepSendDocsStore} from '../store/useStepSendDocsStore';
import {UseQueryParamsSyncProps} from './types';

export function useQueryParamsSync({protocol}: UseQueryParamsSyncProps) {
	const formStep = useStepSendDocsStore(state => state.step);
	const {setSearchParams} = useQueryParams();

	useEffect(() => {
		setSearchParams(
			prev => {
				prev.set(
					QueryParamsForTaggingEnum.SEND_REFUND_DOCS_STEP,
					(formStep + 1).toString(),
				);

				if (protocol) {
					prev.set(QueryParamsForTaggingEnum.SEND_REFUND_DOCS_PROTOCOL_NUMBER, protocol);
				} else {
					prev.delete(QueryParamsForTaggingEnum.SEND_REFUND_DOCS_PROTOCOL_NUMBER);
				}

				return prev;
			},
			{
				replace: true,
			},
		);
	}, [formStep, protocol, setSearchParams]);

	return {
		formStep,
		setSearchParams,
	};
}
